const RAZORPAY_CONFIG = {
  KEY_ID: "rzp_test_SZjJJg6jTF5ech",
  API_URL: "https://api.razorpay.com/v1"
};

class RazorpayService {
  constructor() {
    this.keyId = RAZORPAY_CONFIG.KEY_ID;
  }

  generateReceiptId() {
    return `rcpt_${Date.now()}`;
  }

  async createOrder(amount, currency = "INR") {
    try {
      const response = await fetch(`${RAZORPAY_CONFIG.API_URL}/orders`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount: Math.round(amount * 100),
          currency,
          receipt: this.generateReceiptId()
        })
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error?.description || data.error?.reason || 'Failed to create order');
      }
      return data;
    } catch (error) {
      console.error('Razorpay order creation error:', error);
      throw error;
    }
  }
}

const razorpayService = new RazorpayService();
export default razorpayService;